// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-roi-page {
  display: flex;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  min-height: 0;
}

.option-roi-sidebar {
  width: 220px;
  flex-shrink: 0;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  align-self: flex-start;
}

.option-roi-sidebar h3 {
  margin: 0 0 12px;
  font-size: 1rem;
  color: #333;
}

.option-roi-sidebar p.sidebar-hint {
  margin: 0 0 12px;
  color: #666;
  font-size: 0.85rem;
}

.option-roi-sidebar-badges {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.option-roi-symbol-btn {
  display: block;
  width: 100%;
  min-height: 36px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #667eea;
  background: #fff;
  color: #667eea;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
  box-sizing: border-box;
}

.option-roi-symbol-btn:hover:not(:disabled) {
  background: #667eea;
  color: #fff;
}

.option-roi-symbol-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.option-roi-main {
  flex: 1 1;
  min-width: 0;
}

.option-roi-get-btn {
  min-height: 36px;
  min-width: 100px;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background: #667eea;
  color: #fff;
  cursor: pointer;
  font-size: 0.9rem;
  box-sizing: border-box;
}

.option-roi-get-btn:hover:not(:disabled) {
  background: #5568d3;
}

.option-roi-get-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.option-roi-input {
  min-height: 36px;
  margin-right: 8px;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  text-transform: uppercase;
  font-size: 0.9rem;
  box-sizing: border-box;
}

.option-roi-summary {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.option-roi-meta {
  color: #666;
  font-size: 0.9rem;
}

.option-roi-expiry-block {
  margin-bottom: 24px;
}

.option-roi-expiry-block h5 {
  margin: 0 0 8px;
  font-size: 1rem;
  color: #333;
}

.option-roi-days {
  font-weight: normal;
  color: #666;
}

.option-roi-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.option-roi-table th,
.option-roi-table td {
  padding: 8px 12px;
  text-align: left;
  border: 1px solid #e0e0e0;
}

.option-roi-table th {
  background: #f0f0f0;
  font-weight: 600;
}

.option-roi-th-risk {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.option-roi-risk-info-wrap {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}

.option-roi-risk-info-icon {
  cursor: help;
  font-size: 0.95rem;
  color: #667eea;
  line-height: 1;
}

.option-roi-risk-info-icon:hover {
  color: #5568d3;
}

.option-roi-risk-tooltip {
  visibility: hidden;
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 6px;
  width: 260px;
  padding: 10px 12px;
  background: #333;
  color: #fff;
  font-size: 0.8rem;
  font-weight: normal;
  line-height: 1.4;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  z-index: 10;
  white-space: normal;
  pointer-events: none;
}

.option-roi-risk-info-wrap:hover .option-roi-risk-tooltip {
  visibility: visible;
}

.option-roi-table tbody tr:hover {
  background: #f9f9f9;
}

.option-roi-risk-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  min-height: 28px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
  text-align: center;
  box-sizing: border-box;
  line-height: 1.2;
}

.option-roi-risk-low {
  background: #198754;
  color: #fff;
}

.option-roi-risk-medium {
  background: #fd7e14;
  color: #fff;
}

.option-roi-risk-high {
  background: #dc3545;
  color: #fff;
}

@media (max-width: 768px) {
  .option-roi-page {
    flex-direction: column;
  }
  .option-roi-sidebar {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/OptionROI.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".option-roi-page {\n  display: flex;\n  gap: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 16px;\n  min-height: 0;\n}\n\n.option-roi-sidebar {\n  width: 220px;\n  flex-shrink: 0;\n  background: #f9f9f9;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  align-self: flex-start;\n}\n\n.option-roi-sidebar h3 {\n  margin: 0 0 12px;\n  font-size: 1rem;\n  color: #333;\n}\n\n.option-roi-sidebar p.sidebar-hint {\n  margin: 0 0 12px;\n  color: #666;\n  font-size: 0.85rem;\n}\n\n.option-roi-sidebar-badges {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.option-roi-symbol-btn {\n  display: block;\n  width: 100%;\n  min-height: 36px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #667eea;\n  background: #fff;\n  color: #667eea;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.option-roi-symbol-btn:hover:not(:disabled) {\n  background: #667eea;\n  color: #fff;\n}\n\n.option-roi-symbol-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.option-roi-main {\n  flex: 1;\n  min-width: 0;\n}\n\n.option-roi-get-btn {\n  min-height: 36px;\n  min-width: 100px;\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: none;\n  background: #667eea;\n  color: #fff;\n  cursor: pointer;\n  font-size: 0.9rem;\n  box-sizing: border-box;\n}\n\n.option-roi-get-btn:hover:not(:disabled) {\n  background: #5568d3;\n}\n\n.option-roi-get-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.option-roi-input {\n  min-height: 36px;\n  margin-right: 8px;\n  padding: 8px 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  text-transform: uppercase;\n  font-size: 0.9rem;\n  box-sizing: border-box;\n}\n\n.option-roi-summary {\n  margin-bottom: 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n}\n\n.option-roi-meta {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.option-roi-expiry-block {\n  margin-bottom: 24px;\n}\n\n.option-roi-expiry-block h5 {\n  margin: 0 0 8px;\n  font-size: 1rem;\n  color: #333;\n}\n\n.option-roi-days {\n  font-weight: normal;\n  color: #666;\n}\n\n.option-roi-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.option-roi-table th,\n.option-roi-table td {\n  padding: 8px 12px;\n  text-align: left;\n  border: 1px solid #e0e0e0;\n}\n\n.option-roi-table th {\n  background: #f0f0f0;\n  font-weight: 600;\n}\n\n.option-roi-th-risk {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.option-roi-risk-info-wrap {\n  position: relative;\n  display: inline-flex;\n  flex-shrink: 0;\n}\n\n.option-roi-risk-info-icon {\n  cursor: help;\n  font-size: 0.95rem;\n  color: #667eea;\n  line-height: 1;\n}\n\n.option-roi-risk-info-icon:hover {\n  color: #5568d3;\n}\n\n.option-roi-risk-tooltip {\n  visibility: hidden;\n  position: absolute;\n  right: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-right: 6px;\n  width: 260px;\n  padding: 10px 12px;\n  background: #333;\n  color: #fff;\n  font-size: 0.8rem;\n  font-weight: normal;\n  line-height: 1.4;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.2);\n  z-index: 10;\n  white-space: normal;\n  pointer-events: none;\n}\n\n.option-roi-risk-info-wrap:hover .option-roi-risk-tooltip {\n  visibility: visible;\n}\n\n.option-roi-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.option-roi-risk-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  min-height: 28px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  text-align: center;\n  box-sizing: border-box;\n  line-height: 1.2;\n}\n\n.option-roi-risk-low {\n  background: #198754;\n  color: #fff;\n}\n\n.option-roi-risk-medium {\n  background: #fd7e14;\n  color: #fff;\n}\n\n.option-roi-risk-high {\n  background: #dc3545;\n  color: #fff;\n}\n\n@media (max-width: 768px) {\n  .option-roi-page {\n    flex-direction: column;\n  }\n  .option-roi-sidebar {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
